import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { DATE_FORMAT_DD_MMM_YYYY } from '@/helpers/common';
import { MODAL_IDS } from '@/kit/Modal/keys';
import s from './index.module.scss';

const id = MODAL_IDS.cash_movement_detail;

export const CashMovementDetailModal = props => {
  const { modalIds } = useModal();
  return modalIds[id] && props.data && <Modal {...props} />;
};

export const Modal = ({ data }) => {
  const { t } = useTranslation('modal');
  const { closeModal } = useModal();

  const content = (
    <div className={s.modal}>
      <h1 className="f-article-accent">{t('cash_mv_modal.details')}</h1>
      <div className={s.content}>
        <div className={s.row}>
          <div className="f-small-regular">{t('cash_mv_modal.date')}</div>
          <div className="f-small-accent">
            {prettyDate(data.created_at, DATE_FORMAT_DD_MMM_YYYY)}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('cash_mv_modal.operation_type')}
          </div>
          <div className="f-small-accent">{data.operation_type}</div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('cash_mv_modal.description')}
          </div>
          <div className="f-small-accent">{data.description}</div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">{t('cash_mv_modal.amount')}</div>
          <div className="f-small-accent">
            <span style={{ color: data.amount > 0 ? '#499E1F' : '#E32144' }}>
              {`${data.amount > 0 ? '+' : ''}${prettyFloatMoney(data.amount, {
                decimalPlaces: 2,
              })}`}
            </span>
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">{t('cash_mv_modal.balance')}</div>
          <div className="f-small-accent">
            {prettyFloatMoney(data.balance, {
              decimalPlaces: 2,
            })}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  );
};
